import React from 'react'
import { Badge, Button, Modal, Placeholder, Table } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'
import { URL } from '../../config/url'
import Dashboard from '../../services/Dashboard'
import { dateBR } from '../../utilities/birthdays'
import { formatNumber } from '../../utilities/dashboard'
import { formatarTelefone } from '../../utilities/formatarTelefoneInput'
import { WhatsappButton } from './ActionList'
import { BlockError } from './BlockState'
import { useDashboardBlock } from './hooks'

export const LIST_TITLES = {
  WITHOUT_PRONTUARIO: 'Pacientes sem prontuário',
  WITHOUT_CONTRATO: 'Pacientes sem contrato',
}

const LIST_ORDER = {
  WITHOUT_PRONTUARIO: 'Primeiro quem já teve visita (a mais recente antes), depois os cadastros mais recentes.',
  WITHOUT_CONTRATO: 'Última visita mais recente primeiro.',
}

// Lista de pacientes sem prontuário ou sem contrato, com os filtros da aba (até 100 linhas; o total é o número cheio)
const PacientesListModal = ({ listType, show, filters, onHide, onForbidden }) => {
  const navigate = useNavigate()
  // Busca ao abrir (fechado, não acompanha a troca de filtro)
  const requestKey = show ? `${listType}|${filters.ativo}|${filters.attendance}|${filters.start_date}|${filters.end_date}` : null
  const list = useDashboardBlock(requestKey, () => Dashboard.findPacientesList(listType, filters), onForbidden)
  const rows = list.data?.data || []
  const total = list.data?.total ?? 0

  return (
    <Modal show={show} onHide={onHide} size='xl' scrollable>
      <Modal.Header closeButton>
        <Modal.Title as='h5'>{LIST_TITLES[listType]}{list.data ? ` (${formatNumber(total)})` : ''}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className='dashboard-card-sub mt-0 mb-2'>{LIST_ORDER[listType]}</p>
        {list.error ?
          <BlockError message={list.error} onRetry={list.reload} />
          : !list.data ?
            <Placeholder as='div' animation='glow' aria-hidden='true'>
              {Array.from({ length: 6 }).map((_, index) => <Placeholder key={index} xs={12} className='mb-2' />)}
            </Placeholder>
            : !rows.length ?
              <p className='dashboard-empty'>Nenhum paciente nesta lista.</p>
              :
              <div className={`dashboard-table-wrap ${list.loading ? 'dashboard-stale' : ''}`}>
                <Table size='sm' className='dashboard-table mb-0'>
                  <thead>
                    <tr>
                      <th>Paciente</th>
                      <th>Telefone</th>
                      <th>Cadastro</th>
                      <th>Última visita</th>
                      <th aria-label='Ações' />
                    </tr>
                  </thead>
                  <tbody>
                    {rows.map((row) => {
                      const phone = row.telefone2 || row.telefone
                      return (
                        <tr key={row.paciente_id}>
                          <td>
                            {row.paciente_nome}
                            {(row.ativo === false) ? <Badge bg='secondary' className='ms-2'>INATIVO</Badge> : ''}
                          </td>
                          <td>
                            <span className='d-inline-flex align-items-center gap-2'>
                              {phone ? formatarTelefone(phone) : <span className='dashboard-list-muted'>sem telefone</span>}
                              {phone ? <WhatsappButton paciente={row} /> : ''}
                            </span>
                          </td>
                          <td className='dashboard-num'>{dateBR(row.created_at) || '—'}</td>
                          <td className='dashboard-num'>{dateBR(row.last_visit) || '—'}</td>
                          <td className='text-end'>
                            <Button variant='outline-primary' size='sm' className='dashboard-row-button' onClick={() => navigate(`${URL.pacientes_cadastro}/${row.paciente_id}`)}>
                              Abrir paciente
                            </Button>
                          </td>
                        </tr>
                      )
                    })}
                  </tbody>
                </Table>
              </div>
        }
        {(list.data && (total > rows.length)) ? <p className='dashboard-card-note mt-2 mb-0'>Mostrando {formatNumber(rows.length)} de {formatNumber(total)}.</p> : ''}
      </Modal.Body>
    </Modal>
  )
}

export default PacientesListModal
